import { Component, NgZone, OnInit } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import { TinyMceSetupConfiguration } from '../tiny-mce.setup-configuration';

@Component({
  selector: 'app-editor-edit',
  templateUrl: './editor-edit.component.html',
  styleUrls: ['./editor-edit.component.scss']
})
export class EditorEditComponent implements OnInit {

  editorConfiguration : any = null;
  TinyMCEApiKey: string | null = 'ubtpj59o1fxeg9j8jwahvfud9thxpcm0pm7kqusisjhgtxsq';
  control: FormControl = new FormControl(null);

  constructor(private ngZone: NgZone) { }

  ngOnInit() {

    //this.setup()

  }

  setup(configuration?: TinyMceSetupConfiguration) {

    this.editorConfiguration = null;

    setTimeout(() => {

      this.editorConfiguration = {

        selector: "#myEditor",
        menubar: false, //  "file edit insert view format table tools", PREMIUM
        branding: false,
        language_url: "/assets/i18n/it.json",  // site absolute URL
        language: "it",
        plugins: ['code', 'fullpage'],
        pagebreak_separator: "<p style='page-break-after: always'></p>",
        toolbar1: "undo redo copy  | styles fontfamily fontsizeinput forecolor | bold italic underline | alignleft aligncenter alignright alignjustify |  table | pagebreak",
        toolbar2: "html_content | dynamic_fields_button",
        toolbar_mode: "floating", // Disabilita gli ellipsis e permetti agli elementi di andare a capo
        setup: (editor: any) => this.setupEditor(editor, configuration),
        force_br_newlines: false,
        apply_source_formatting: false,
        verify_html: false,
        valid_elements: "*[*]",
        valid_children : "+body[style]",
        extended_valid_elements: 'style[type|media]',
        content_style: `
        @page { size: A4; margin: 2cm; }
        body {
          width: 21cm;
          min-height: 29.7cm;
          margin: 2cm auto;
          padding: 1cm;
          background: white;
          border: 1px solid #ccc;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
      `,
        height: 842, // Altezza A4 in pixel (equivalente a 29.7 cm a 96 DPI)
        cleanup: false,
        cleanup_on_startup: false,
        fullpage_default_doctype: '<!DOCTYPE html>',
        entity_encoding: "raw",
        allow_conditional_comments: true,
        convert_urls: false,
        protect: [
          /<!--\[if \(!mso\)&\(!IE\)\]>/g, // Protect <!--[if (!mso)&(!IE)]>
          /<!-->/g                        // Protect <!-->
        ]
      };

    }, 0);


    if (configuration?.initialValue) {

      this.setValue(configuration.initialValue);

    }

    if (configuration?.validators) {

      this.setControlValidators(configuration.validators);

    }

  }

  private setValue(value: string | null) {

    setTimeout(() => {

      this.control.setValue(value);
      this.control.updateValueAndValidity();
    }, 1000);

  }

  setControlValidators(validators: ValidatorFn | ValidatorFn[] | null) {

    this.control.setValidators(validators);
    this.control.updateValueAndValidity();

  }

  private async setupEditor(editor: any, configuration?: TinyMceSetupConfiguration) {

    // serve per gestire i caratteri di tabulazione, però genera problemi UX, se per esempio voglio cambiare cella in una tabella, con questa funzione l'editor non mi consente più di farlo
    // editor.on("keydown", function(event: any) {
    //   if (event.key === "Tab") {
    //     // Inserisci un carattere di tabulazione nell'editor
    //     editor.execCommand("mceInsertContent", false, "&emsp;&emsp;");
    //     event.preventDefault();
    //     return false;
    //   }
    // });


    editor.ui.registry.addButton("html_content", {
      text: "HTML",
      onAction: () => this.ngZone.run(() => {}), // creare logiche
      icon: "code-sample"
    });

  }

}
